/**
 * Режимът на терминала — срещу облака (`cloud`) или срещу главната каса
 * (`local`) — и всичко, което го движи (§8 и §13.1 на договора, docs/edge.md):
 *
 *  • сесия (`edgeSession.ts`): при вход и при всяка смяна на токена —
 *    конфигурация, билет, една сонда `GET {edge}/health` (prompt-ът „Local
 *    Network Access" на Chrome), таймери;
 *  • сонди с хистерезис: в `cloud` мрежова грешка от axios (или WS-а на
 *    мониторите, или `offline` събитието — САМО подсказки, `navigator.onLine`
 *    не е източник на истина), или заявка, мълчала 1,5 s, пуска
 *    `GET {cloud}/health` на 2 s. Колко провала са нужни, за да се замрази
 *    обектът, решава ВТОРИЯТ СВИДЕТЕЛ — касата (`edgeCloudWitness.ts`), а не
 *    само този терминал. В `local` сондата продължава на 5 s (асиметрията е
 *    умишлена) и пита и касата (`GET {edge}/sync-state` на всеки тик — оттам
 *    идват `synced` и броят неразрешени за лентата); 3 поредни успеха на
 *    облака И синхронизирана каса без неразрешени → `cloud`. А излязла ли е
 *    САМАТА каса (тя се връща първа, §18.7), терминалът я следва ВЕДНАГА, без
 *    да чака своите три успеха: от този миг тя отказва всяка негова мутация с
 *    409 и „локален" е задънена улица, не резерв;
 *
 *  • ШЕСТТЕ СЪСТОЯНИЯ на връзката (`edgeSlice.linkState`) и праговете им:
 *
 *      online          всичко е наред; спокоен пулс на 20 s
 *      slow            заявка мълчи 1,5 s → лента „бавно" + бърза фаза
 *      suspect         сондата се провали; пита се и касата
 *      device_offline  касата вижда облака ЖИВ → проблемът е само в ТОВА
 *                      устройство. `mode/enter` НЕ се вика НИКОГА — той
 *                      замразява ЦЕЛИЯ обект, а другите работят. Изходът
 *                      оттук е ЧОВЕК с право `manage_devices` (бутонът в
 *                      лентата), или обръщането на свидетелството
 *      app_down        и двамата виждат жива мрежа с мъртво приложение →
 *                      чака се 60 s, защото това почти винаги е наш деплой
 *      local           замразено, работи се срещу касата
 *
 *    Едната посока е бърза (4 сонди при свидетел „и аз не го виждам"), другата
 *    предпазлива (10 сонди без свидетел, 30 при мъртво приложение) — цената на
 *    ранното замразяване е целият обект, цената на закъснението е 20 s;
 *  • студен старт без облак (§13.1): кеширан `local` в `edge_mode` →
 *    ПАРАЛЕЛНИ сонди към облака и към касата (§14.4) и `local` само ако
 *    облакът мълчи, а касата отговаря; без кеш/кеширан `cloud` — първата
 *    мрежова грешка, преди облакът да е отговорил в това зареждане, пуска
 *    същите две сонди. Хистерезисът остава за вече работеща сесия (без
 *    премигване) и за връщането към облака;
 *  • старт БЕЗ токен (§15.4): изходът трие билета и `edge_mode`, но не и
 *    `edge_last_known` — запомнената каса — затова и излязъл терминал пуска
 *    същите две сонди и при мълчащ облак влиза в ограничен режим, а екранът
 *    за вход праща към касата;
 *  • ограничен локален режим (§14.3.1): без билет за активния токен касата
 *    приема само `POST {edge}/user/login` и `/user/login-with-code`, затова
 *    `mode/enter` не се вика и екраните показват вход; първият успешен
 *    локален вход носи билет → store-ът се замразява и режимът е пълен;
 *  • самоличност (`edgeIdentity.ts`): всяко превключване на режима пуска
 *    `fetchUserInfo()` за влезлия човек (§13.1 — в `local` касата го сервира
 *    от snapshot-а); на общ терминал без служител гейтът повтаря
 *    възстановяването сам (`routes/useEmployeeSessionRestore.ts`); а след
 *    вход СРЕЩУ КАСАТА опитът се повтаря, докато ролите се получат (§16.4 №5),
 *    иначе терминалът остава влязъл, но без достъп до нито един модул;
 *  • връщане в облака (§15.5, §17.1): решава КАСАТА, не променлива в паметта —
 *    всяка сонда я пита `GET {edge}/sync-state` (`edgeSyncState.ts`) и се чака
 *    `synced == true`, `mode == "cloud"` И нула НЕРАЗРЕШЕНИ действия (такива,
 *    които облакът е отказал и чакат човек при касата). Без отговор от нея две
 *    поредни сонди — връщаме се без проверката, с предупреждение в лога.
 *    ЕДНО изключение: терминал БЕЗ токен (излязъл по време на аварията) си
 *    тръгва на първата жива сонда — той няма какво да загуби, а докато стои
 *    долу, входът му се минтва от касата напразно и после се трие;
 *  • локален билет като `access_token` (ПИН вход без интернет) при връщане се
 *    РАЗМЕНЯ за истински токен (`POST /user/exchange-edge-ticket`): той е
 *    подписан със секрета на ресторанта и облакът умее да го провери. Провали
 *    ли се размяната (мрежа, 401, 409 капацитет, стар облак без endpoint-а),
 *    важи заварената пътека — служителят слиза до ПИН екрана.
 *
 * Заедно с `edgeRuntime.ts`/`edgeSession.ts` това е ЕДИНСТВЕНИЯТ писач на
 * Redux `edgeSlice` и на `edgeState.ts`. Инициализира се веднъж от
 * `main.tsx` (`initEdge`) — извън React дървото, защото режимът трябва да е
 * известен на axios интерсептора преди първия рендер.
 */
import type { QueryClient } from "@tanstack/react-query";
import {
  enterEdgeLocalMode,
  isCloudIsUpRefusal,
  leaveEdgeLocalMode,
  probeCloudVerdict,
  resolveCloudBillId,
  type CloudVerdict,
  type EdgeModeEnterReason,
} from "../../api/edge";
import { exchangeEdgeTicket } from "../../api/auth";
import {
  restoreEmployeeSession,
  switchToNonPersonal,
} from "../../store/authSlice";
import { setSelectedBillId } from "../../store/billSlice";
import {
  setCloudReachable,
  setEdgeLinkState,
  setEdgeManualOverride,
  setEdgeSynced,
  type EdgeLinkState,
} from "../../store/edgeSlice";
import {
  beginTerminalSession,
  clearEmployeeRecordIf,
  getAccountIsPersonal,
  getTerminalToken,
  writeEmployeeRecord,
} from "../auth";
import { fullLogout } from "../sessionRecovery";
import { readCachedEdgeConfig } from "./edgeConfig";
import {
  askCloudWitness,
  forgetCloudWitness,
  witnessSaysTillIsLocal,
  witnessVerdict,
  type WitnessVerdict,
} from "./edgeCloudWitness";
import {
  ensureIdentityAfterLocalLogin,
  refreshIdentityAfterModeSwitch,
} from "./edgeIdentity";
import { edgeConfigFromLastKnown, readEdgeLastKnown } from "./edgeLastKnown";
import { readCachedEdgeMode, writeCachedEdgeMode } from "./edgeModeCache";
import {
  applyConfig,
  currentToken,
  devLog,
  getActiveEdgeTicket,
  getEdgeRuntime,
  isEdgeRestrictedNow,
  setEdgeRuntime,
  setMode,
  syncEdgeRestricted,
  warnLog,
  type EdgeRuntime,
  type EdgeStore,
} from "./edgeRuntime";
import {
  handleTokenChange,
  probeEdgeReachability,
  restartSession,
} from "./edgeSession";
import {
  forgetEdgeSyncState,
  isEdgeFullySynced,
  refreshEdgeSyncState,
  type EdgeSyncSnapshot,
} from "./edgeSyncState";
import {
  getEdgeBaseUrl,
  getEdgeConfigState,
  hasCloudRespondedThisLoad,
  isEdgeLocalMode,
  markCloudResponded,
  onCloudFence,
  onCloudNetworkError,
  onCloudResponded,
  onCloudSlow,
} from "./edgeState";
import { isLocalEdgeToken, markLocalTicketDropped } from "./edgeTicket";

/** Бърза фаза: докато нещо не е наред, въпросът се задава на всеки 2 s. */
const FAST_PROBE_INTERVAL_MS = 2_000;
/**
 * Спокоен пулс: когато всичко е наред, облакът пак се пита — рядко. Без него
 * терминал, който никой не пипа половин час, научава за аварията чак когато
 * сервитьорът натисне бутон, тоест най-късно възможно.
 */
const CALM_PULSE_INTERVAL_MS = 20_000;
/**
 * В локален режим се сондира по-рядко (5 s) — асиметрията е УМИШЛЕНА:
 * влизането трябва да е бързо, за да не спре работата, а излизането —
 * спокойно, защото то отнема сметките от касата и ги връща в облака.
 */
const LEAVE_PROBE_INTERVAL_MS = 5_000;
/** Касата също не вижда облака: обектът е без интернет → 4 × 2 s ≈ 8 s. */
const FAILURES_WITH_WITNESS_DOWN = 4;
/** Свидетел няма (мълчаща каса, стар билд, остаряла присъда) → 10 × 2 s = 20 s. */
const FAILURES_WITHOUT_WITNESS = 10;
/**
 * ТАВАН на брояча, докато касата вижда облака жив (`device_offline`).
 *
 * Броячът нарочно ПРОДЪЛЖАВА да тече там: обърне ли се свидетелството, обектът
 * влиза на следващата сонда, без да се брои отначало. Но без таван терминал,
 * стоял час в мъртва точка на Wi-Fi-а, трупа стотици провала — и в мига, в
 * който касата млъкне за секунда (рестарт на услугата: присъдата ѝ е
 * `unknown`, тоест предпазливият праг 10), ги осребрява наведнъж и замразява
 * ЦЕЛИЯ обект при жив облак. Това е Д1 през задната врата.
 *
 * Таванът е прагът на ПОТВЪРДЕНАТА авария: „касата също ослепя" пак влиза
 * веднага, а „касата млъкна" пак иска пълните си 10 сонди.
 */
const FAILURES_CAP_WHILE_DEVICE_OFFLINE = FAILURES_WITH_WITNESS_DOWN;
/**
 * Мрежата е жива, приложението е мъртво, и двамата го виждат → 30 × 2 s = 60 s.
 * Това е нашият деплой: обект не бива да се замразява заради качване на нова
 * версия, а 60 s са повече от всяко превключване на pod.
 */
const FAILURES_BOTH_APP_DOWN = 30;
/**
 * След отказ от касата (409 `cloud_is_up`) не се пита пак толкова време.
 * Отказът значи „само ти си без интернет" — повтарянето в цикъл не поправя
 * нищо, а товари касата точно когато тя е единственото работещо нещо.
 */
const ENTER_RETRY_AFTER_REFUSAL_MS = 30_000;
const CLOUD_SUCCESSES_TO_LEAVE_LOCAL = 3;
// Облакът е жив, а касата не отговаря на `GET {edge}/status` (рестарт,
// изключен edge, стара каса, която иска билет): след толкова поредни провала
// (~10 s) се връщаме в облака БЕЗ проверката за синхронизация, с
// предупреждение в лога (§15.5) — иначе терминалът остава срещу мъртва каса.
const EDGE_STATUS_FAILURES_TO_LEAVE_LOCAL = 2;
/**
 * Най-много толкова често терминалът, натиснал ръчното превключване, моли
 * касата да го отмени сам (§19.5). Сондата в локален режим е на 5 s, а
 * отмяната пуска replay на касата — повторът след неуспех (мрежа, изтекъл
 * бюджет) е за следващата половин минута, не за следващия тик.
 */
const MANUAL_HOLD_RELEASE_RETRY_MS = 30_000;
//: Локалните номера на касата (§16.3) — огледало на `LOCAL_BILL_ID_FLOOR`
//: в BE-то и на брояча в FiscalAPI.
const LOCAL_BILL_ID_FLOOR = 1_000_000_000;

let lastToken: string | null = null;
let probeTimer: number | null = null;
let probeIntervalMs = 0;
let probeInFlight = false;
/** Тик, паднал ВЪВ времето на летяща сонда — наваксва се, щом тя се върне. */
let probeTickMissed = false;
let cloudFailures = 0;
let cloudSuccesses = 0;
let edgeStatusFailures = 0;
let linkState: EdgeLinkState = "online";
/** Кога касата за последно отказа замразяване (виж ENTER_RETRY_AFTER_REFUSAL_MS). */
let enterRefusedAt: number | null = null;
/** Кога този терминал за последно помоли касата да отмени ръчното задържане
 * (виж MANUAL_HOLD_RELEASE_RETRY_MS). Нулира се при излизане. */
let manualHoldReleaseAt: number | null = null;
// Студен старт: „веднага в локален режим" при първата мрежова грешка е само
// веднъж на зареждане; едновременните опити споделят една сонда.
let firstErrorEntryUsed = false;
let immediateEntry: Promise<void> | null = null;
// Викан ли е успешно `POST {edge}/mode/enter` в ТОВА зареждане — само за да
// не се праща пак при всяка смяна на токена и на всяка сонда. НЕ е отговор на
// въпроса „замразена ли е касата": след reload той е false, а касата може да е
// замразена от предишното зареждане с неизпратен дневник. Затова връщането в
// облака пита самата каса (§15.5), а не тази променлива.
let edgeStoreFrozenThisLoad = false;

// ─── Инициализация ─────────────────────────────────────────────────────────

export function initEdge(store: EdgeStore, queryClient: QueryClient) {
  if (getEdgeRuntime()) return;
  setEdgeRuntime(store, queryClient);
  // Кешираната конфигурация още преди първата заявка — старт без облак.
  applyConfig(readCachedEdgeConfig());

  onCloudNetworkError((kind) => {
    if (isEdgeLocalMode()) return;
    // Видът на провала (5xx срещу мъртва мрежа) влиза само в лога: ЕДИНСТВЕНИЯТ
    // източник на четиризначната присъда е `GET {cloud}/health`, иначе един
    // 500 от счупена справка би обявил облака за мъртъв.
    devLog(`cloud request failed (${kind})`);
    noteTrouble("suspect");
    if (!getEdgeConfigState()?.enabled) return;
    if (!hasCloudRespondedThisLoad() && !firstErrorEntryUsed) {
      // Студен старт без облак: не чакаме десет сонди — контролна към облака,
      // една към касата и ВЪПРОС КЪМ КАСАТА какво вижда тя (§14.4,
      // паралелно). Веднъж на зареждане; матрицата важи и тук.
      firstErrorEntryUsed = true;
      void tryEnterLocalNow("първа мрежова грешка преди отговор от облака");
      return;
    }
    applyProbeSchedule(true);
  });
  // Заявка, която мълчи 1,5 s, още не е провал — но е достатъчна причина да
  // се пита облакът, вместо да се чака бюджетът ѝ да изтече (api/timeouts.ts).
  onCloudSlow(() => {
    if (isEdgeLocalMode()) return;
    noteTrouble("slow");
    applyProbeSchedule(true);
  });
  // 423 от облака: той САМ е решил, че обектът е локален. Няма какво да се
  // проверява и няма какво да се чака.
  onCloudFence(() => {
    if (isEdgeLocalMode()) return;
    void enterLocalModeNow("cloud_fence", "облакът върна 423 (fence)");
  });
  // Всеки отговор от облака сваля съмнението веднага — иначе лентата „бавно"
  // виси до следващата сонда, след като заявката отдавна се е върнала.
  onCloudResponded(() => noteCloudAlive());
  window.addEventListener("offline", () => {
    if (isEdgeLocalMode()) return;
    noteTrouble("suspect");
    applyProbeSchedule(true);
  });
  window.addEventListener("online", () => {
    if (probeTimer !== null) void runProbe();
  });

  lastToken = currentToken();
  store.subscribe(() => {
    const token = currentToken();
    if (token === lastToken) return;
    lastToken = token;
    handleTokenChange(token);
    // §14.3.1: локалният вход срещу касата връща билет като `access_token` —
    // ограниченият режим става пълен и store-ът на касата се замразява.
    syncEdgeRestricted();
    void freezeEdgeStoreIfPending();
    // §16.4 №5: и ролите за този локален вход — ако първият опит на екрана за
    // вход се е разминал с касата, терминалът щеше да остане без тях.
    if (token && isEdgeLocalMode() && isLocalEdgeToken(token)) {
      void ensureIdentityAfterLocalLogin(token);
    }
  });
  handleTokenChange(lastToken);
  if (lastToken) void resumeCachedLocalMode();
  else void resumeLoggedOutLocalMode();
  // Спокойният пулс тръгва веднага и БЕЗ да гледа дали резервът е включен:
  // състоянието на връзката се показва на всеки обект, а замразяването си
  // остава заключено зад `enabled`. Без него терминал, който никой не пипа,
  // научава за аварията чак когато сервитьорът посегне към бутон.
  applyProbeSchedule(false);
}

// ─── Студен старт (§13.1) ──────────────────────────────────────────────────

/** Кеширан `local` от предишното зареждане → двете сонди и при мълчащ облак
 * с жива каса — локален режим веднага, без трите сонди. */
async function resumeCachedLocalMode() {
  const cached = readCachedEdgeMode();
  if (cached?.mode !== "local") return;
  if (!getEdgeConfigState()?.enabled || !getEdgeBaseUrl()) {
    devLog("cached local mode, but the fallback is off — staying in cloud");
    return;
  }
  await tryEnterLocalNow("кеширан локален режим при старт");
}

/**
 * §15.4: старт БЕЗ токен. Изходът трие билета, кеширания режим и
 * самоличността, но не и запомнената каса (`edge_last_known`) — тя не е нито
 * билет, нито самоличност. Затова и терминал, от когото някой е излязъл преди
 * прекъсването, тръгва срещу касата: двете сонди (§14.4) решават, и при
 * мълчащ облак с жива каса режимът е ОГРАНИЧЕН (билет няма откъде да дойде),
 * тоест екранът за вход праща потребител и парола към касата. Влезе ли се,
 * локалният билет прави режима пълен (`freezeEdgeStoreIfPending`).
 *
 * Конфигурацията се сглобява от запомненото САМО когато кешът `edge_config`
 * го няма или е без адрес: с кеш той остава източникът на истина.
 */
async function resumeLoggedOutLocalMode() {
  const lastKnown = readEdgeLastKnown();
  if (!lastKnown?.enabled || !lastKnown.ip) return;
  if (!getEdgeBaseUrl()) applyConfig(edgeConfigFromLastKnown(lastKnown));
  if (!getEdgeBaseUrl()) return;
  await tryEnterLocalNow("старт без токен с запомнена каса");
}

/**
 * Влизане в локален режим при СТУДЕН СТАРТ. §14.4: сондите вървят ПАРАЛЕЛНО
 * и жив облак ЗАБРАНЯВА влизането — `mode/enter` замразява касата за ЦЕЛИЯ
 * обект, а другите терминали може да работят.
 *
 * Дотук този път беше единственият БЕЗ свидетел: питаше само себе си и при
 * мълчащ облак замразяваше обекта. Терминал със счупен Wi-Fi, презареден в
 * 19:05, спираше ресторанта в пика. Сега важи СЪЩАТА матрица като при
 * сондите — с една добавка, която важи само тук: каса, която ВЕЧЕ е
 * замразена, се посреща веднага, защото обектът и без това работи срещу нея.
 *
 * Едновременните повиквания споделят един опит.
 */
function tryEnterLocalNow(reason: string): Promise<void> {
  if (immediateEntry) return immediateEntry;
  immediateEntry = (async () => {
    const runtime = getEdgeRuntime();
    if (!runtime || isEdgeLocalMode() || !getEdgeConfigState()?.enabled) return;
    devLog(`probing both sides before entering local mode: ${reason}`);
    const [verdict, edgeOk, witness] = await Promise.all([
      probeCloudVerdict(),
      probeEdgeReachability(),
      askCloudWitness(),
    ]);
    runtime.store.dispatch(setCloudReachable(verdict === "up"));
    if (verdict === "up") {
      // Контролната сонда завари облака жив: това не е авария, а бавна или
      // отпаднала единична заявка — оставаме в облака.
      markCloudResponded();
      rememberCloudMode();
      return;
    }
    if (!edgeOk) {
      // Няма и каса — нищо не може да се направи освен да се следи.
      noteTrouble("suspect");
      applyProbeSchedule(false);
      return;
    }
    if (witnessSaysTillIsLocal(witness)) {
      // Касата е замразена: обектът работи срещу нея и единственото, което
      // този терминал би постигнал сам в облака, е сметки на две места.
      await enterLocalMode("probe");
      return;
    }
    const judgment = judge(verdict, witnessVerdict(witness));
    if (!judgment.confirmed) {
      // Свидетелят или казва „облакът е жив" (значи проблемът е само тук), или
      // не е сигурен — и в двата случая се минава през хистерезиса, вместо
      // един терминал да замрази обект по собствена преценка.
      cloudFailures = 1;
      setLinkState(judgment.state);
      applyProbeSchedule(false);
      return;
    }
    // Касата ПОТВЪРЖДАВА, че и тя не вижда облака: обектът е без интернет и
    // няма какво да се доказва с още девет сонди.
    await enterLocalMode("probe");
  })().finally(() => {
    immediateEntry = null;
  });
  return immediateEntry;
}

// ─── Състояние на връзката (шестте положения) ──────────────────────────────

/** i18n ключът, който отговаря на всяко положение. */
const LINK_MESSAGES: Record<EdgeLinkState, string | null> = {
  online: null,
  slow: "edge.linkSlow",
  suspect: "edge.linkSuspect",
  device_offline: "edge.linkDeviceOffline",
  app_down: "edge.linkAppDown",
  local: "edge.linkLocal",
};

export const getEdgeLinkState = (): EdgeLinkState => linkState;

function setLinkState(next: EdgeLinkState, message?: string | null) {
  const text = message === undefined ? LINK_MESSAGES[next] : message;
  const runtime = getEdgeRuntime();
  if (linkState === next) {
    // Същото положение, но може да е с друг текст (напр. „проверява се"
    // става „няма връзка", когато вече няма и какво да се опита).
    runtime?.store.dispatch(setEdgeLinkState({ state: next, message: text }));
    return;
  }
  devLog(`link state: ${linkState} → ${next}`);
  linkState = next;
  runtime?.store.dispatch(setEdgeLinkState({ state: next, message: text }));
  // Честотата СЛЕДВА положението: съмнението пита на 2 s, спокойствието — на
  // 20 s. Без този ред авария, хваната от спокойния пулс, щеше да се решава
  // със скоростта на спокойния пулс — 30 сонди × 20 s вместо × 2 s.
  applyProbeSchedule(false);
}

/**
 * Нещо не е наред, но още не знаем какво. Надолу по стълбата се слиза само
 * с ДОКАЗАТЕЛСТВО (отговор от облака), затова по-конкретните положения —
 * `device_offline` и `app_down`, дадени от матрицата — не се заменят с
 * „съмнение".
 */
function noteTrouble(kind: "slow" | "suspect") {
  if (isEdgeLocalMode()) return;
  if (kind === "slow") {
    if (linkState === "online") setLinkState("slow");
    return;
  }
  if (linkState === "online" || linkState === "slow") setLinkState("suspect");
}

/**
 * Облакът отговори — на сонда или на истинска заявка. Това е ДОКАЗАТЕЛСТВО и
 * сваля всяко съмнение наведнъж. В локален режим не пипа нищо: излизането
 * оттам иска три поредни успеха И съгласието на касата (§15.5).
 */
function noteCloudAlive() {
  if (isEdgeLocalMode()) return;
  cloudFailures = 0;
  enterRefusedAt = null;
  if (linkState !== "online") setLinkState("online");
}

/** Облакът отговори в режим `cloud` — кешът за студен старт да не казва
 * `local` от предишно зареждане (иначе всеки старт първо сондира касата). */
function rememberCloudMode() {
  if (readCachedEdgeMode()?.mode !== "local") return;
  const config = getEdgeConfigState();
  writeCachedEdgeMode({
    mode: "cloud",
    localSince: null,
    ip: config?.ip ?? null,
    port: config?.port ?? 8787,
  });
}

// ─── Сонди с хистерезис ────────────────────────────────────────────────────

/** Колко често трябва да се пита при ТЕКУЩОТО положение. */
function desiredProbeInterval(): number {
  if (isEdgeLocalMode()) return LEAVE_PROBE_INTERVAL_MS;
  return linkState === "online"
    ? CALM_PULSE_INTERVAL_MS
    : FAST_PROBE_INTERVAL_MS;
}

/**
 * Изравнява таймера с положението. `runNow` е за случаите, когато нещо току-що
 * се е случило (грешка, бавна заявка) — тогава въпросът се задава веднага,
 * вместо да се чака следващият тик. При успокояване се подава `false`: няма
 * смисъл от сонда точно след като облакът е отговорил.
 */
function applyProbeSchedule(runNow: boolean) {
  const interval = desiredProbeInterval();
  if (probeTimer !== null && probeIntervalMs === interval) {
    if (runNow) void runProbe();
    return;
  }
  if (probeTimer !== null) clearInterval(probeTimer);
  probeIntervalMs = interval;
  probeTimer = window.setInterval(() => void runProbe(), interval);
  if (runNow) void runProbe();
}

function stopProbing() {
  if (probeTimer !== null) {
    clearInterval(probeTimer);
    probeTimer = null;
    probeIntervalMs = 0;
  }
  probeTickMissed = false;
  cloudFailures = 0;
  cloudSuccesses = 0;
  edgeStatusFailures = 0;
}

/** Решението „колко провала стигат" — цялата матрица на едно място. */
interface Judgment {
  state: EdgeLinkState;
  /** Колко ПОРЕДНИ провала са нужни за замразяване; `null` = никога. */
  limit: number | null;
  /** Свидетелят потвърждава аварията — студеният старт може да влезе веднага. */
  confirmed: boolean;
}

/**
 * Двамата свидетели → колко се чака. Единственото място, което решава това;
 * и сондите, и студеният старт минават през него.
 *
 * Редът на проверките е редът на сигурността:
 *  1. касата ВИЖДА облака → проблемът е в това устройство. НИКАКВО замразяване,
 *     колкото и дълго да продължи: обектът работи;
 *  2. касата вижда мъртво ПРИЛОЖЕНИЕ (жива мрежа) → нашият деплой. 60 s;
 *  3. касата също не вижда нищо → обектът е без интернет. 8 s;
 *  4. касата мълчи или не знае → предпазливо, 20 s.
 *
 * Собствената присъда на терминала не мени праговете: „и аз, и касата не
 * виждаме" е същото като „касата не вижда". Тя има значение само за случай 1,
 * където прихващащ прокси на ТОЗИ терминал (`app_down` при жив облак) е
 * точно толкова „проблем само тук", колкото и мъртвият Wi-Fi.
 */
function judge(mine: CloudVerdict, witness: WitnessVerdict): Judgment {
  if (witness === "up") {
    return { state: "device_offline", limit: null, confirmed: false };
  }
  if (witness === "app_down") {
    return {
      state: "app_down",
      limit: FAILURES_BOTH_APP_DOWN,
      confirmed: false,
    };
  }
  if (witness === "down") {
    return {
      state: "suspect",
      limit: FAILURES_WITH_WITNESS_DOWN,
      confirmed: true,
    };
  }
  devLog(`no witness for the cloud (mine: ${mine}) — the cautious threshold`);
  return { state: "suspect", limit: FAILURES_WITHOUT_WITNESS, confirmed: false };
}

/**
 * Един тик на сондата. Между два тика НИКОГА не се застъпват две сонди — но
 * пропуснатият тик не се хвърля, а се НАВАКСВА (`probeTickMissed`).
 *
 * Без наваксване тактът се удвоява точно при истинската авария: сондата към
 * облака има таймаут, равен на интервала (2 s), а при изгубени SYN пакети тя
 * изяжда целия си бюджет. Тикът на 2000 ms пада ВЪВ времето ѝ, изхвърля се, и
 * следващата сонда тръгва чак на 4000 ms. Обещаните „4 сонди ≈ 8 s" стават 14 s,
 * „10 сонди = 20 s" стават 38 s — а стендът не го вижда, защото моковете му се
 * решават мигновено. Оттук нататък числата в матрицата са верни и на мрежа.
 */
async function runProbe(): Promise<void> {
  const runtime = getEdgeRuntime();
  if (!runtime) return;
  if (probeInFlight) {
    probeTickMissed = true;
    return;
  }
  probeInFlight = true;
  try {
    // Цикъл, а не рекурсия: на болна мрежа наваксването тече часове наред,
    // а верига от вложени обещания с такава дължина е теч на памет на терминал,
    // който никой не презарежда по цяла смяна.
    do {
      probeTickMissed = false;
      await runProbeOnce(runtime);
    } while (probeTickMissed);
  } finally {
    probeInFlight = false;
  }
}

async function runProbeOnce(runtime: EdgeRuntime) {
  const verdict = await probeCloudVerdict();
  const cloudOk = verdict === "up";
  if (cloudOk) markCloudResponded();
  runtime.store.dispatch(setCloudReachable(cloudOk));

  if (!isEdgeLocalMode()) {
    await runCloudModeProbe(verdict);
    return;
  }

  // ИЗЛЯЗЪЛ терминал при ЖИВ облак си тръгва ВЕДНАГА — без трите успеха и без
  // съгласието на касата.
  //
  // Изходът по време на авария е SPA навигация, не презареждане: токенът,
  // билетите и кешът на режима си отиват, но режимът В ПАМЕТТА остава `local`
  // и няма кой да го върне на `cloud`. Оттам нататък екранът за вход праща
  // към КАСАТА (`api/auth.ts::authBaseUrl`), тя приема всеки вход и издава
  // ЛОКАЛЕН билет, който се записва като терминален токен — а при връщането на
  // облака точно този билет се смята за изтекъл и токенът се трие. Човекът
  // вижда „входът не работи, докато не натисна F5" (при СТАРТ режимът се
  // преизчислява срещу жива сонда, в движение — не).
  //
  // Без токен няма какво да се пази: локални сметки не се губят (те са на
  // касата и си стоят там), билет няма, дневник няма. Затова тук не важат нито
  // трите поредни успеха, нито `synced`/`unresolved` — те пазят РАБОТЕЩА
  // сесия, а такава няма. Терминал С ТОКЕН минава по стария път непокътнат.
  if (cloudOk && currentToken() === null) {
    warnLog("logged out while the cloud is back — leaving local mode at once");
    await leaveLocalMode();
    return;
  }

  // В локален режим всяка сонда пита и КАСАТА (§17.1 т.5): броят
  // неразрешени действия трябва да стигне до лентата веднага, а не чак
  // когато облакът се върне — човекът на смяна научава, че нещо чака при
  // касата, докато още има кой да отиде до нея.
  const syncState = await refreshEdgeSyncState(getEdgeBaseUrl());

  if (!cloudOk) {
    cloudSuccesses = 0;
    edgeStatusFailures = 0;
    // Билетът може да е дошъл (локален вход) или да е изтекъл в движение —
    // локалният е с TTL 24 h и една дълга авария го надживява. Затова и
    // ограниченият режим се преизчислява тук: иначе терминалът би стоял с
    // отказани заявки, вместо да поиска нов вход (§14.3.1).
    syncEdgeRestricted();
    void freezeEdgeStoreIfPending();
    await leaveIfTillIsBackInCloud(syncState);
    return;
  }
  cloudSuccesses += 1;
  if (cloudSuccesses < CLOUD_SUCCESSES_TO_LEAVE_LOCAL) return;
  await leaveIfEdgeSynced(syncState);
}

/** Една сонда в облачен режим: присъда → свидетел → праг → решение. */
async function runCloudModeProbe(verdict: CloudVerdict) {
  if (verdict === "up") {
    noteCloudAlive();
    rememberCloudMode();
    return;
  }
  cloudFailures += 1;
  const witness = await askCloudWitness();
  const judgment = judge(verdict, witnessVerdict(witness));

  // Замразена каса: обектът вече работи срещу нея. Ветото ѝ („облакът е жив")
  // няма какво да пази — замразяването е факт, а терминал, останал в облака,
  // само би разпилял сметките на две места.
  const tillIsLocal = witnessSaysTillIsLocal(witness);
  if (judgment.limit === null && !tillIsLocal) {
    // Касата вижда облака: този терминал е сам в бедата си.
    parkAsDeviceOffline();
    return;
  }
  if (enterRefusedRecently()) {
    // Касата вече отказа: докато трае прозорецът ѝ, положението си остава
    // „само това устройство". Без този ред следващата сонда би го върнала на
    // „проверява се" и човекът щеше да чете ту едното, ту другото.
    parkAsDeviceOffline();
    return;
  }
  setLinkState(tillIsLocal ? "suspect" : judgment.state);

  const limit = tillIsLocal ? 1 : (judgment.limit ?? Number.POSITIVE_INFINITY);
  if (cloudFailures < limit) return;
  if (!getEdgeConfigState()?.enabled) {
    // Няма резерв за този обект — състоянието е честно, но няма какво да се
    // включва; сондите продължават, за да се хване връщането на облака.
    setLinkState(linkState, "edge.linkLostNoFallback");
    return;
  }
  if (!(await probeEdgeReachability())) return;
  await enterLocalMode("probe");
}

/**
 * „Само това устройство": лентата го казва, броячът ПРОДЪЛЖАВА да тече (обърне
 * ли се свидетелството, влизането е на следващата сонда), но с ТАВАН — виж
 * `FAILURES_CAP_WHILE_DEVICE_OFFLINE`.
 */
function parkAsDeviceOffline() {
  cloudFailures = Math.min(cloudFailures, FAILURES_CAP_WHILE_DEVICE_OFFLINE);
  setLinkState("device_offline");
}

/** Отказала ли е касата наскоро (409 `cloud_is_up`). */
function enterRefusedRecently(): boolean {
  if (enterRefusedAt === null) return false;
  if (Date.now() - enterRefusedAt < ENTER_RETRY_AFTER_REFUSAL_MS) return true;
  enterRefusedAt = null;
  return false;
}

/**
 * §15.5: облакът се върна — но решението „може ли терминалът обратно" е на
 * КАСАТА (`GET {edge}/sync-state`, вече попитана от сондата). Връщаме се само
 * при `synced == true`, `mode == "cloud"` И нула неразрешени: касата е
 * изпратила дневника си, облакът е приел `done` и не е останало нищо, което
 * той е отказал. Не се гледа никакъв флаг в паметта — след reload той не знае
 * за замразена каса с неизпратен дневник.
 *
 * §17.1: неразрешените (`unresolved`) СПИРАТ връщането, колкото и да е жив
 * облакът. Те са продажби, които съществуват само в дневника на касата и
 * чакат човек при нея; излезе ли терминалът, локалните сметки си отиват с
 * него, а горе ги няма. Лентата казва на сервитьора точно това.
 *
 * Без отговор от касата (мъртва, изключен резерв, стара версия, която иска
 * билет за статуса) се връщаме БЕЗ проверката след две поредни неуспешни
 * сонди, с предупреждение в лога: терминал, залостен срещу каса, която я
 * няма, е по-лошо от терминал, който е изпреварил синхронизацията.
 */
async function leaveIfEdgeSynced(syncState: EdgeSyncSnapshot | null) {
  const runtime = getEdgeRuntime();
  if (!runtime) return;
  if (!getEdgeBaseUrl()) {
    // Няма кого да питаме (резервът е изключен или касата не обявява адрес).
    warnLog("no edge address — leaving local mode without the sync check");
    await leaveLocalMode();
    return;
  }
  if (syncState) {
    edgeStatusFailures = 0;
    if (isEdgeFullySynced(syncState)) {
      await leaveLocalMode();
      return;
    }
    if (isOwnManualHoldReadyToRelease(syncState)) {
      await releaseOwnManualHold();
    }
    return;
  }
  edgeStatusFailures += 1;
  if (edgeStatusFailures < EDGE_STATUS_FAILURES_TO_LEAVE_LOCAL) return;
  warnLog(
    `edge status unreachable ${edgeStatusFailures}× while the cloud is up — leaving local mode without the sync check`,
  );
  await leaveLocalMode();
}

/**
 * §19.5: касата стои в локален режим по РЪЧНО решение, натиснато от ТОЗИ
 * терминал, а той вече вижда облака сам (викащият го е доказал с поредните
 * успехи на сондата). Касата не излиза сама — решението на човека е лепкаво —
 * а самочистенето ѝ чака десет минути БЕЗ терминал по нея, които никога не
 * идват, докато този терминал я пита на 5 s. Без отмяна двете страни се чакат
 * взаимно и лентата „изчаква се касата да изпрати…" виси над празен дневник
 * (полеви тест 23.09.2026).
 *
 * САМО натисналият отменя сам: решението е взето, защото ТОЙ не е виждал
 * облака, и щом го вижда, причината я няма. Терминал, който е имал интернет
 * през цялото време (влязъл долу по оградата на облака), би отменил чуждото
 * решение за секунди — на него лентата дава бутон, не автоматика.
 */
function isOwnManualHoldReadyToRelease(syncState: EdgeSyncSnapshot): boolean {
  return (
    syncState.mode === "local" &&
    syncState.manualOverride &&
    syncState.manualOverrideByThisDevice &&
    syncState.synced &&
    syncState.unresolved === 0 &&
    !isEdgeRestrictedNow()
  );
}

/** Изходите на молбата към касата да отмени ръчното задържане. */
type ManualHoldReleaseResult = "released" | "pending" | "noTill" | "failed";

/**
 * `POST {edge}/mode/leave`. `released` = касата вече е в облака; `pending` =
 * флагът е махнат, но касата още не е излязла (тогава излиза сама по обичайните
 * си правила и сондата го вижда).
 */
async function requestManualHoldRelease(): Promise<ManualHoldReleaseResult> {
  const base = getEdgeBaseUrl();
  const ticket = getActiveEdgeTicket();
  if (!base || !ticket) return "noTill";
  try {
    const answer = await leaveEdgeLocalMode(base, ticket);
    getEdgeRuntime()?.store.dispatch(setEdgeManualOverride(false));
    return answer.mode === "cloud" ? "released" : "pending";
  } catch (error) {
    devLog("mode/leave failed", error);
    return "failed";
  }
}

async function releaseOwnManualHold(): Promise<void> {
  if (
    manualHoldReleaseAt !== null &&
    Date.now() - manualHoldReleaseAt < MANUAL_HOLD_RELEASE_RETRY_MS
  ) {
    return;
  }
  manualHoldReleaseAt = Date.now();
  warnLog(
    "the till is held in local mode by a decision made on THIS terminal and the cloud is back here — asking the till to release it",
  );
  const result = await requestManualHoldRelease();
  // Касата е в облака, а условията на `isEdgeFullySynced` бяха изпълнени
  // (дневникът е качен, нула неразрешени) — същото връщане като обичайното.
  if (result === "released") await leaveLocalMode();
}

/**
 * §18.7: КАСАТА вече е горе, а този терминал още се мисли за локален.
 *
 * Случва се при всяко връщане: касата излиза първа (изпратила е дневника си и
 * е изчистила локалните документи), а терминал в мъртва точка на Wi-Fi-а не
 * получава своите три успешни сонди към ОБЛАКА и остава `local`. От този миг
 * всяка негова мутация минава през `store.ensure_local` на касата, ветото ѝ
 * вижда жив облак и връща 409 `cloud_is_up` — а лентата казва „работи се срещу
 * касата". Тоест сервитьорът чете, че всичко е наред, докато нищо не минава,
 * и няма как да излезе: бутонът за ръчно превключване се показва само в
 * ОБЛАЧЕН режим.
 *
 * Излизането е единственият честен изход. Локални сметки не се губят — касата
 * ги е качила (`synced`, нула НЕРАЗРЕШЕНИ; ако има неразрешени, тя още е
 * `local` и този ред не се задейства). Горе терминалът ще види, че облакът
 * мълчи САМО за него, и лентата ще каже точно това.
 *
 * ОГРАНИЧЕНИЯТ режим (§14.3.1) е изключен нарочно: там касата НИКОГА не е
 * замразявана, `mode == "cloud"` е нормалното ѝ състояние, а излизането би
 * върнало терминала на екран за вход срещу облак, който го няма.
 *
 * ИЗКЛЮЧЕН е и терминал, чийто СОБСТВЕН токен е локален билет (22.09.2026,
 * находка на червения отбор — ПРИМКАТА). Този терминал е влизал с парола срещу
 * касата по време на аварията, тоест в облака няма нищо негово. Излезе ли,
 * размяната не може да успее (към облака той няма път — това е самото условие
 * на §18.7), долният блок стига до `fullLogout()`, а екранът за вход вече сочи
 * към ОБЛАКА (`api/auth.ts::authBaseUrl` избира по режима). Обратно в локален
 * режим не се влиза, защото сондата вижда каса с жив облак и паркира на
 * „само това устройство" — тоест пет секунди след успешен вход човекът е
 * изгонен и няма къде да влезе. Оставането е по-малкото зло: касата отказва
 * записите с 409, но четенето работи, сесията е жива и в мига, в който мрежата
 * на устройството се върне, нормалните сонди излизат както трябва. Лентата
 * казва точно това, вместо „работи се срещу касата".
 */
async function leaveIfTillIsBackInCloud(
  syncState: EdgeSyncSnapshot | null,
): Promise<void> {
  if (!syncState || isEdgeRestrictedNow()) return;
  if (!isEdgeFullySynced(syncState)) return;
  if (isLocalEdgeToken(getTerminalToken())) {
    warnLog(
      "the till is back in cloud mode but this terminal only has a local ticket — staying local, leaving would log it out with nowhere to log back in",
    );
    setLinkState("local", "edge.tillBackTerminalBlind");
    return;
  }
  warnLog(
    "the till is back in cloud mode while this terminal is still local — leaving, the till refuses every write now",
  );
  // Размяна не се опитва: условието на §18.7 Е „този терминал не вижда облака",
  // тоест заявката би изяла целия си бюджет само за да падне.
  await leaveLocalMode({ exchangeTicket: false });
}

// ─── Вход/изход от локален режим ───────────────────────────────────────────

/**
 * Влизане в локален режим. Иска САМО адрес на касата и здрава каса (§14.3.1):
 *  • има ли билет за активния токен — режимът е ПЪЛЕН: `POST {edge}/mode/enter`
 *    замразява store-а на касата и тя поема четенето и писането;
 *  • няма ли билет (терминал, изгасен през нощта: билетът е с TTL 24 h и се
 *    подновява само онлайн) — режимът е ОГРАНИЧЕН: касата не се замразява,
 *    през нея минават само двата login-а, а екраните показват вход. Първият
 *    успешен локален вход носи билет и режимът става пълен.
 */
async function enterLocalMode(
  reason: EdgeModeEnterReason,
) {
  const runtime = getEdgeRuntime();
  if (!runtime || isEdgeLocalMode()) return;
  const base = getEdgeBaseUrl();
  if (!base) {
    devLog("cannot enter local mode without edge address");
    return;
  }

  const ticket = getActiveEdgeTicket();
  if (ticket) {
    const localSince = await freezeEdgeStore(base, ticket, reason);
    // Билет има, но касата не пое — оставаме срещу облака и сондите опитват пак.
    if (localSince === null) return;
    setMode("local", localSince);
  } else {
    devLog("no ticket — entering restricted local mode (login only)");
    setMode("local", null);
  }

  setLinkState("local");
  forgetCloudWitness();
  runtime.store.dispatch(setEdgeSynced(false));
  cloudSuccesses = 0;
  edgeStatusFailures = 0;
  cloudFailures = 0;
  // Всичко в кеша е от облака — презарежда се срещу касата.
  void runtime.queryClient.invalidateQueries();
  // В ограничен режим няма кого да опресним — самоличността идва с локалния вход.
  if (!isEdgeRestrictedNow()) refreshIdentityAfterModeSwitch();
  // Връщането към облака се следи от сондите — и когато влизането не е
  // дошло от тях (студен старт).
  applyProbeSchedule(false);
}

/**
 * Влизане БЕЗ проверки — за двата случая, в които няма какво да се проверява:
 * облакът сам е върнал 423 и човек е решил на място. Споделя ключалката на
 * студения старт, за да не се засекат две влизания.
 */
function enterLocalModeNow(
  reason: EdgeModeEnterReason,
  why: string,
): Promise<void> {
  // Тече ли опит от студения старт, изчакваме го и чак тогава решаваме: той
  // може да е стигнал до „НЕ влизай" (свидетелят вижда облака жив), а 423 и
  // ръчното решение не подлежат на обсъждане. Споделянето на обещанието му
  // би глътнало точно тях.
  const pending = immediateEntry;
  if (pending) {
    return pending.then(() =>
      isEdgeLocalMode() ? undefined : enterLocalModeNow(reason, why),
    );
  }
  immediateEntry = (async () => {
    if (isEdgeLocalMode()) return;
    devLog(`entering local mode without probing: ${why}`);
    if (!(await probeEdgeReachability())) {
      warnLog(`${why}, but the till is unreachable — staying in cloud mode`);
      return;
    }
    await enterLocalMode(reason);
  })().finally(() => {
    immediateEntry = null;
  });
  return immediateEntry;
}

/** `POST {edge}/mode/enter` — замразява store-а на касата. Връща `local_since`
 * или null при провал (мрежа, изтекъл билет, ОТКАЗ от касата). */
async function freezeEdgeStore(
  base: string,
  ticket: string,
  reason: EdgeModeEnterReason,
): Promise<string | null> {
  try {
    const entered = await enterEdgeLocalMode(base, ticket, reason);
    edgeStoreFrozenThisLoad = true;
    enterRefusedAt = null;
    return entered.local_since ?? new Date().toISOString();
  } catch (error) {
    if (isCloudIsUpRefusal(error)) {
      // Касата вижда облака в този момент и не замразява обекта заради едно
      // устройство (§ветото). Това НЕ е повод за нов опит в цикъл: състоянието
      // е ясно и се показва на човека.
      warnLog("the till refused to freeze: it sees the cloud up");
      enterRefusedAt = Date.now();
      // В ЛОКАЛЕН режим лентата се води по `mode` (`CloudLinkBanner`): писането
      // на „само това устройство" тук би разсинхронизирало модулната променлива
      // с това, което човекът чете. Отказът тогава значи друго — „касата вече е
      // горе" — и с него се занимава `leaveIfTillIsBackInCloud`.
      if (!isEdgeLocalMode()) setLinkState("device_offline");
      return null;
    }
    devLog("mode/enter failed", error);
    return null;
  }
}

/**
 * §14.3.1: ограниченият режим стана пълен — локалният вход срещу касата даде
 * билет (самият `access_token`), значи store-ът вече може да се замрази.
 * Вика се при всяка смяна на активния токен.
 */
async function freezeEdgeStoreIfPending() {
  const runtime = getEdgeRuntime();
  if (!runtime || !isEdgeLocalMode() || edgeStoreFrozenThisLoad) return;
  const base = getEdgeBaseUrl();
  const ticket = getActiveEdgeTicket();
  if (!base || !ticket) return;
  // През ветото, както всяко друго замразяване от сонда: върнал ли се е
  // облакът, докато човекът е въвеждал ПИН-а си, касата отказва — и следващата
  // сонда връща терминала горе, вместо да го остави замразен без нужда.
  const localSince = await freezeEdgeStore(base, ticket, "probe");
  if (localSince === null) return;
  setMode("local", localSince);
  runtime.store.dispatch(setEdgeSynced(false));
  void runtime.queryClient.invalidateQueries();
}

/**
 * §16.3: сметка, отворена ДОКАТО е нямало интернет, се води с локалния си
 * номер (≥ `LOCAL_BILL_ID_FLOOR`). Върне ли се терминалът в облака, списъкът
 * носи вече облачния номер, а маркиращият екран държи стария — `selectedBill`
 * става `undefined` и сервитьорът гледа празен екран със заредена сметка.
 *
 * Затова преди превключването питаме облака под кой номер е горе. Мълчи ли
 * (стар BE, мрежата пак е паднала, дневникът още не е стигнал) — оставяме
 * както е: облакът превежда псевдонима сам (`features/sync/aliases.py`),
 * тоест действията пак минават, а изгледът „Маси" се самопоправя при първия
 * избор.
 */
async function remapSelectedLocalBill(runtime: EdgeRuntime): Promise<void> {
  const selected = runtime.store.getState().bills.selectedBillId;
  if (selected === null || selected < LOCAL_BILL_ID_FLOOR) return;
  try {
    const cloudBillId = await resolveCloudBillId(selected);
    if (cloudBillId !== null) {
      devLog(`local bill ${selected} is ${cloudBillId} in the cloud`);
      runtime.store.dispatch(setSelectedBillId(cloudBillId));
    }
  } catch (error) {
    warnLog("bill alias lookup failed", error);
  }
}

/**
 * РАЗМЯНА на локалния билет за истински облачен токен при връщането (§Д7).
 *
 * Досега билетът, минтнат от касата при вход без интернет, просто се хвърляше:
 * служителят, влязъл с ПИН по време на аварията, слизаше до ПИН екрана в мига,
 * в който интернетът се върне. Но билетът е HMAC-SHA256 със СЕКРЕТА НА
 * РЕСТОРАНТА, а облакът има и секрета, и проверката — значи може да бъде
 * РАЗМЕНЕН вместо изхвърлен (`POST /user/exchange-edge-ticket`).
 *
 * Новият токен се записва по СЪЩИЯ път, по който го записва нормалният вход:
 *  • билетът е самият терминален токен (терминалът е влизал срещу касата) →
 *    `beginTerminalSession`, както `login.fulfilled`;
 *  • билетът е служителският Y на общ терминал → `writeEmployeeRecord`, както
 *    `loginWithCode.fulfilled`.
 * И в двата случая Redux получава новия токен, а `store.subscribe` в `initEdge`
 * пуска нова сесия (конфигурация, билет, сонда) сам.
 *
 * Връща `false` при ВСЕКИ провал — мрежа, 401 (невалиден/изтекъл билет), 409
 * (няма място по лиценз), 404 (по-стар облак без endpoint-а) — и тогава
 * викачът прави точно каквото правеше досега. Обратната съвместимост със стар
 * облак не е по избор: този код тръгва към каси, чийто облак още не знае за
 * размяната.
 *
 * НЕ се опитва, когато И терминалният токен, И активният са локални билети
 * (терминалът е влизал с парола срещу касата, после служител с ПИН). Тогава
 * една размяна оставя другия билет мъртъв в localStorage и човекът пак пада —
 * само по-късно и с 401 на случаен екран. Двойната размяна е втора задача:
 * тя ражда две облачни сесии и половин успех, който яде място по лиценза.
 */
async function exchangeLocalTicketForToken(
  runtime: EdgeRuntime,
  ticket: string,
): Promise<boolean> {
  const terminalToken = getTerminalToken();
  const isTerminalTicket = terminalToken === ticket;
  if (!isTerminalTicket && isLocalEdgeToken(terminalToken)) {
    devLog("both the terminal token and the active one are local — no exchange");
    return false;
  }
  try {
    const session = await exchangeEdgeTicket(ticket);
    if (isTerminalTicket) {
      beginTerminalSession({
        token: session.access_token,
        personal: session.personal,
        sharedName:
          session.personal === false
            ? session.names || session.username || null
            : null,
      });
    } else {
      writeEmployeeRecord(session.access_token);
    }
    // Единственият редуктор, който само слага токен в Redux — оттам го четат
    // и `currentToken()`, и абонаментът, който пуска новата сесия.
    runtime.store.dispatch(
      restoreEmployeeSession({
        token: session.access_token,
        cachedUserInfo: null,
      }),
    );
    warnLog("the local ticket was exchanged for a cloud token — session kept");
    // Ролите идват от ОБЛАКА вече, не от snapshot-а на касата.
    refreshIdentityAfterModeSwitch();
    return true;
  } catch (error) {
    // Шумно, но НЕ фатално: оттук нататък важи заварената пътека.
    warnLog("edge ticket exchange failed — falling back to the login screen", error);
    return false;
  }
}

/** Какво да НЕ се прави на излизане. `exchangeTicket: false` значи „не питай
 * облака за размяна" — ползва се по пътя на §18.7, където този терминал по
 * определение не вижда облака и заявката само би изяла бюджета си. */
interface LeaveLocalModeOptions {
  exchangeTicket?: boolean;
}

async function leaveLocalMode(options: LeaveLocalModeOptions = {}) {
  const runtime = getEdgeRuntime();
  if (!runtime) return;
  setMode("cloud", null);
  edgeStoreFrozenThisLoad = false;
  forgetEdgeSyncState();
  forgetCloudWitness();
  stopProbing();
  enterRefusedAt = null;
  manualHoldReleaseAt = null;
  setLinkState("online");
  // Спокойният пулс поема наблюдението — обратно към облака значи обратно към
  // въпроса „още ли е там" на всеки 20 s.
  applyProbeSchedule(false);

  // Локалният билет е „изтекъл" за облака: служител на общ терминал слиза
  // до ПИН екрана (терминалният токен X е облачен и остава); личен акаунт с
  // локален билет няма как да има, но за всеки случай — пълен изход.
  // Токенът се запомня ПРЕДИ dispatch-а: смени ли се, store.subscribe вече
  // е пуснал нова сесия и втора оттук би била дубликат.
  //
  // ПРЕДИ това обаче се опитва РАЗМЯНА (`exchangeLocalTicketForToken`): билетът
  // е подписан със секрета на ресторанта и облакът умее да го провери, тоест
  // връщането на интернета не е причина човекът да пада до ПИН екрана насред
  // смяна. Провали ли се размяната — по каквато и да е причина — долният блок
  // остава точно както е бил.
  const token = currentToken();
  if (token && isLocalEdgeToken(token)) {
    const kept =
      options.exchangeTicket !== false &&
      (await exchangeLocalTicketForToken(runtime, token));
    if (!kept) {
      const terminalToken = getTerminalToken();
      if (
        getAccountIsPersonal() === false &&
        terminalToken &&
        !isLocalEdgeToken(terminalToken)
      ) {
        // Оттук човекът излиза на ПИН екрана — маркерът носи ЗАЩО
        // (`CodeKeypad.tsx`), иначе изглежда като изгонване без причина.
        markLocalTicketDropped();
        clearEmployeeRecordIf(token);
        runtime.store.dispatch(switchToNonPersonal());
      } else {
        // Пълен изход: следващият екран е този за вход и той сам се обяснява,
        // затова маркер за ПИН екрана НЕ се пише — иначе би висял в
        // sessionStorage и би изскочил при следващия ПИН вход без повод.
        fullLogout();
        return;
      }
    }
  }

  await remapSelectedLocalBill(runtime);
  void runtime.queryClient.invalidateQueries();
  // При същия токен сесията се пуска оттук — билетът и конфигурацията са от
  // преди прекъсването; самоличността се опреснява от облака.
  const next = currentToken();
  if (next && next === token) {
    restartSession();
    refreshIdentityAfterModeSwitch();
  }
}

// ─── Ръчно превключване (§човекът над автоматиката) ────────────────────────

/**
 * Правото, с което се пуска локалният режим НАСИЛА. Билетът за касата НЕ носи
 * права (`edgeTicket.ts`: uid, username, personal — и толкова), затова
 * проверката е по същото право, което пази реда „Локален резерв" в
 * Конфигурация → Устройства: `manage_devices`. В локален режим то идва от
 * snapshot-а на касата, тоест важи и без интернет.
 *
 * Изборът е съзнателен: замразяването спира ЦЕЛИЯ обект и не е решение на
 * сервитьор в движение, а на човека, който отговаря за касата.
 */
export const EDGE_MANUAL_OVERRIDE_PERMISSION = "manage_devices";

/** Изходите на ръчното превключване — по един за всяко нещо, което човекът
 * трябва да направи после. */
export type EdgeForceLocalOutcome =
  | "entered"
  | "alreadyLocal"
  | "noPermission"
  | "disabled"
  | "noTill"
  | "failed";

/** Има ли влезлият човек право да замрази обекта. Викащият го пита ПРЕДИ да
 * покаже бутона — иначе бутон, който само отказва, е по-лош от липсващ. */
export function canForceEdgeLocalMode(): boolean {
  const runtime = getEdgeRuntime();
  if (!runtime) return false;
  return runtime.store
    .getState()
    .auth.permissions.some((p) => p.name === EDGE_MANUAL_OVERRIDE_PERMISSION);
}

/**
 * „Включи локалния режим сега" — когато автоматиката откаже, а човекът вижда,
 * че обектът не работи.
 *
 * Причината `manual_override` минава ПОКРАЙ ветото на касата: тя ще се съгласи
 * дори да вижда облака жив, и ще го запише шумно в лога си. Затова и правото се
 * проверява тук, а не се разчита на това, че бутонът е скрит — Redux е в
 * браузъра на терминала.
 *
 * `skipPermissionCheck` е за повикващ, който вече е проверил по друг начин
 * (напр. екран, пуснат само след потвърждение с код). Самата функция никога
 * не пита човека — диалогът е работа на UI-я.
 */
export async function forceEdgeLocalMode(options?: {
  skipPermissionCheck?: boolean;
}): Promise<EdgeForceLocalOutcome> {
  if (isEdgeLocalMode()) return "alreadyLocal";
  if (!options?.skipPermissionCheck && !canForceEdgeLocalMode()) {
    return "noPermission";
  }
  if (!getEdgeConfigState()?.enabled) return "disabled";
  if (!getEdgeBaseUrl()) return "noTill";
  warnLog("manual override: entering local mode by a human decision");
  // Ръчното решение изчиства следата от отказа — иначе 30-те секунди тишина
  // след 409 биха глътнали точно този натиснат бутон.
  enterRefusedAt = null;
  await enterLocalModeNow("manual_override", "ръчно превключване от човек");
  return isEdgeLocalMode() ? "entered" : "failed";
}

/** Изходите на „Върни към облака". */
export type EdgeReleaseManualHoldOutcome =
  | "released"
  | "pending"
  | "notLocal"
  | "noPermission"
  | "noTill"
  | "failed";

/**
 * „Върни към облака" (§19.1, §19.5) — обратното на `forceEdgeLocalMode`, за
 * обект, задържан в локален режим по РЪЧНО решение. Касата сама не излиза
 * (нарочно), а автоматичната отмяна е само за устройството, натиснало
 * превключването; всеки друг терминал стига дотук с бутона.
 *
 * Правото е СЪЩОТО като на влизането: отмяната също засяга ЦЕЛИЯ обект —
 * терминал, който още е без мрежа, след нея остава без каса, срещу която да
 * работи. Самото излизане на ТОЗИ терминал не се решава тук: пуска се сонда и
 * тя го прави по обичайните правила (§15.5; §18.7, ако облакът не се вижда
 * оттук).
 */
export async function releaseEdgeManualHold(): Promise<EdgeReleaseManualHoldOutcome> {
  if (!isEdgeLocalMode()) return "notLocal";
  if (!canForceEdgeLocalMode()) return "noPermission";
  warnLog("manual override: a human asks the till to return to the cloud");
  const result = await requestManualHoldRelease();
  if (result === "released" || result === "pending") {
    manualHoldReleaseAt = Date.now();
    void runProbe();
  }
  return result;
}
